import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import draggable from "vuedraggable";
import Goods from "./Goods";
export default {
    props: {
        modelValue: {
            type: Array,
            default: ()=>[]
        }
    },
    components: {
        Goods,
        draggable
    },
    data () {
        return {
            dialog: {
                save: false
            },
            value: []
        };
    },
    watch: {
        modelValue: {
            handler (val) {
                this.value = val;
            },
            deep: true,
            immediate: true
        },
        value (val) {
            this.$emit('update:modelValue', val);
        }
    },
    computed: {
        previewSrcList ({ value }) {
            return value.map((item)=>item.image);
        }
    },
    methods: {
        choose () {
            this.dialog.save = true;
            this.$nextTick(()=>{
                this.$refs.GoodsDialog.open();
            });
        },
        handleSuccess (data) {
            let tempData = this.$TOOL.objCopy(this.value);
            tempData = tempData.concat(data);
            tempData = this.$TOOL.uniqueFunc(tempData, 'id');
            this.value = tempData;
        },
        deleteData (index) {
            this.value.splice(index, 1);
        }
    }
};
